module.exports = __webpack_public_path__ + "static/img/nft_bj.46faf4a0.png";